var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownarrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 261,
    viewBox: "0 0 59 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0913 259.388L6.36513 220.198L53.9839 219.099L31.0913 259.388Z",
    fill: "#FA3966"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3086 191.393L5.58241 152.202L53.2011 151.104L30.3086 191.393Z",
    fill: "#FA3966"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5029 121.397L4.77675 82.2071L52.3955 81.1085L29.5029 121.397Z",
    fill: "#FA3966"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3266 53.4078L4.18486 13.8549L51.8146 13.4633L28.3266 53.4078Z",
    fill: "#FA3966"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownarrow);
export default __webpack_public_path__ + "static/media/downarrow.e8f921fb8b9d4d786b446e68854b0f38.svg";
export { ForwardRef as ReactComponent };